import { snackbarUtils } from '@ahamove/web-components/lib/SnackbarProvider';
import { QueryClient } from '@tanstack/react-query';
import type { DefaultQueryError } from '@/api/types';
import { ERROR_CODE } from './constants';

const onError = (e: unknown) => {
  const errorCode = (e as DefaultQueryError).response?.data.code;

  switch (errorCode) {
    case ERROR_CODE.NOT_AUTHORIZED:
    case ERROR_CODE.NOT_ENOUGH_BALANCE:
    case ERROR_CODE.AMS_ALREADY_HAVE_ANOTHER_RENTING_ORDER:
    case ERROR_CODE.AMS_INVALID_KYC_PROFILE:
      return;

    default:
      snackbarUtils.error(
        (e as DefaultQueryError).response?.data?.description ||
          (e as DefaultQueryError).response?.data?.title ||
          (e as Error).message
      );
      return;
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError,
    },
    queries: {
      retry: false, // If set to a number, failed queries will retry until the failed query count reaches that number.
      retryOnMount: false, // If true, the query will re-fetch on mount if the cached data is stale.
      refetchOnWindowFocus: false, // If "always", the query will always re-fetch in the background on window focus.
      refetchOnReconnect: false, // Defaults to true . If true, the query will re-fetch on reconnect if the cached data is stale
      staleTime: 5 * 60 * 1000, // The time in milliseconds after data becomes stale.
      onError,
    },
  },
});
